import { FC, useState } from 'react';
import { ExtendedGridColDef } from '@/types/ExtendedGridColDef';
import { Grid, Box } from '@mui/material';
import { SCUIContent } from '../../atomic/organisms';
import { SCUICustomDataGrid } from '../../atomic/molecules';
import { SCUIButton, SCUITextField } from '../../atomic/atoms';
import { GiftCardQuery } from '../../services/query';
import { useTranslation } from 'react-i18next';

export const CardBalanceInquiry: FC<any> = () => {
    const { t } = useTranslation();
    const [cardNumber, setCardNumber] = useState('');
    const [transactions, setTransactions] = useState<any[]>([]);
    const [loading, setLoading] = useState(false);

    const columns: ExtendedGridColDef[] = [
        { field: 'sequence', headerName: t('cardBalanceInquiry.sequence'), flex: 1 },
        { field: 'date', headerName: t('cardBalanceInquiry.date'), flex: 1 },
        { field: 'time', headerName: t('cardBalanceInquiry.time'), flex: 1 },
        { field: 'cardNumber', headerName: t('cardBalanceInquiry.cardNumber'), flex: 1 },
        { field: 'orderNumber', headerName: t('cardBalanceInquiry.orderNumber'), flex: 1 },
        { field: 'transactionType', headerName: t('cardBalanceInquiry.transactionType'), flex: 1 },
        { field: 'initialAmount', headerName: t('cardBalanceInquiry.initialAmount'), flex: 1 },
        { field: 'transactionAmount', headerName: t('cardBalanceInquiry.transactionAmount'), flex: 1 },
        { field: 'remainingAmount', headerName: t('cardBalanceInquiry.remainingAmount'), flex: 1 },
        { field: 'storeCode', headerName: t('cardBalanceInquiry.storeCode'), flex: 1 },
        { field: 'terminalCode', headerName: t('cardBalanceInquiry.terminalCode'), flex: 1 },
        { field: 'transferredCard', headerName: t('cardBalanceInquiry.transferredCard'), flex: 1 },
        { field: 'createdBy', headerName: t('cardBalanceInquiry.createdBy'), flex: 1 },
    ];

    const handleSearch = () => {
        if (!cardNumber) return;
        setLoading(true);
        GiftCardQuery.GetGiftCardTransactionReport({ cardNumber })
            .then((res: any) => {
                const items = res?.items || res?.data?.items || res?.data || [];
                if (Array.isArray(items) && items.length > 0) {
                    const dataWithId = items.map((item: any, index: number) => ({
                        ...item,
                        id: item.sequence || index,
                    }));
                    setTransactions(dataWithId);
                } else {
                    setTransactions([]);
                }
            })
            .catch((error: any) => {
                console.error(error);
                setTransactions([]);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    return (
        <SCUIContent>
            <Box className="card-balance-inquiry">
                <Grid
                    className="card-balance-inquiry-title"
                    size={{
                        lg: 12,
                        md: 12,
                        xs: 12,
                    }}
                    mb={3}
                >
                    <h1 className="headtxt">{t('cardBalanceInquiry.title')}</h1>
                </Grid>
                <Grid className="card-balance-inquiry-search" container spacing={2} alignItems="center" mb={2}>
                    <Grid
                        className="card-balance-inquiry-card-number-field"
                        size={{
                            md: 4,
                            xs: 12,
                        }}
                    >
                        <SCUITextField
                            label={t('cardBalanceInquiry.cardNumber')}
                            value={cardNumber}
                            onChange={(val: string) => setCardNumber(val)}
                            stateName="cardNumber"
                            fullWidth
                        />
                    </Grid>
                    <Grid
                        className="card-balance-inquiry-actions"
                        size={{
                            md: 2,
                            xs: 12,
                        }}
                    >
                        <SCUIButton
                            className="card-balance-inquiry-query-button"
                            type="primary"
                            sizeType="default"
                            size="m"
                            text={t('cardBalanceInquiry.query')}
                            onClick={handleSearch}
                            disabled={loading}
                        />
                    </Grid>
                </Grid>
                <Box className="card-balance-inquiry-data-grid">
                    <SCUICustomDataGrid rows={transactions} columns={columns} loading={loading} />
                </Box>
            </Box>
        </SCUIContent>
    );
};